export default __webpack_public_path__ + "static/media/lockrScan-dashboard-selected.d8aa889b.svg";